module.exports = __webpack_public_path__ + "static/media/briefcase.591a8bd8.svg";